import { render, staticRenderFns } from "./newGoodsSort.vue?vue&type=template&id=0720cc0a&scoped=true"
import script from "./newGoodsSort.vue?vue&type=script&lang=js"
export * from "./newGoodsSort.vue?vue&type=script&lang=js"
import style1 from "./newGoodsSort.vue?vue&type=style&index=1&id=0720cc0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0720cc0a",
  null
  
)

export default component.exports